import React, { useEffect, useRef, useState } from 'react';
import Button from 'components/base/Button';
import { IS_TIGER_SELF } from 'utils/constants';
import bannerDarkImg from './banner-dark.png';
import bannerDefaultImg from './banner.png';
import './errorbox.scss';

export interface ErrorBoxProps {
    error: Error | string;
    title?: string;
    onClick?: React.MouseEventHandler;
    btnContent?: string;
}

export interface ErrorBoxState {
    loading: boolean;
}

const ErrorBox: React.FC<ErrorBoxProps> = ({ title, onClick, error, btnContent }) => {
    const [isLoading, setLoading] = useState(false);
    const mountRef = useRef(false);
    const banner = IS_TIGER_SELF ? bannerDefaultImg : bannerDarkImg;

    useEffect(() => {
        mountRef.current = true;

        return () => {
            mountRef.current = false;
        };
    }, []);

    const errorMsg = error instanceof Error ? error.message : error;
    const onBtnClick = async ev => {
        try {
            setLoading(true);

            await onClick?.(ev);
        } catch {}

        if (mountRef.current) {
            setLoading(false);
        }
    };

    return (
        <div className="errorbox-root">
            <img className="eb-banner" src={banner} alt="errorbox banner" />
            {title && <h4 className="eb-title">{title}</h4>}
            <p className="error-msg">{errorMsg}</p>
            {onClick && (
                <Button className="eb-btn" onClick={onBtnClick} type="primary" loading={isLoading} disabled={isLoading}>
                    {btnContent || __('Retry')}
                </Button>
            )}
        </div>
    );
};

export default ErrorBox;
